import { Log } from "@/services/log.service";

/**
 *  AbstractModel:
 *  Basis-Klasse für alle anderen Objekte
 * 
 */
class AbstractModel {
	
	constructor( data ) {
		this.setData(this.defaultData);
		this.setData(data);
		this.createUid(data);
	}

	setData( data ) {
		Object.assign(this, data);
	}

	createUid( data ) {}
}

export default AbstractModel;


// WEBPACK FOOTER //
// ./src/models/AbstractModel.js